(function ($) {
    'use strict';

    /**
     * Переключатель между двумя значениями
     * @returns {jQuery}
     */
    $.fn.sortSwitch = function () {
        var $self = $(this);
        var $options = $self.find('.js-sort-option');
        var $toggle = $self.find('.js-sort-toggle');

        /**
         * Получить состояние переключателяв
         * @returns {boolean}
         */
        var getState = function () {
            return $toggle.hasClass('switched');
        };

        /**
         * Установить состояние переключателя
         * @param {boolean} state
         */
        var setState = function (state) {
            state = !!state; // cast to boolean
            $toggle.toggleClass('switched', state);
            $options.first().toggleClass('active', !state);
            $options.last().toggleClass('active', state);
        };

        /**
         * Вызвать событие, содержащее данные о состоянии переключателя
         */
        var triggerEvent = function () {
            $self.trigger('sortSwitch', {
                state: getState()
            });
        };

        /**
         * ИНициализация
         */
        var init = function () {
            setState(false);

            // обработка событий
            $toggle.on('click', function () {
                setState(!getState());
                triggerEvent();
            });
            $options.on('click', function () {
                setState($(this).index());
                triggerEvent();
            });
        };

        init();

        this.getState = getState;
        this.setState = setState;
        this.triggerEvent = triggerEvent;

        return this;
    };

    $('.js-sort-switch').each(function () {
        $(this).data('sortSwitch', $(this).sortSwitch());
    });
})(jQuery);
